import { Client, Company } from "../../types";

export const B = ({ children }: { children: React.ReactNode }) => (
  <strong className="font-bold uppercase">{children}</strong>
);

export const N = ({ i }: { i: string }) => (
  <span className="font-bold mr-6">{i}.</span>
);

export const L = ({ l, pad }: { l: string; pad?: boolean }) => (
  <span className={`mr-6 ${pad ? "ml-6" : ""}`}>
    {l}
    {")"}
  </span>
);

export const InlineCompany = ({ company }: { company: Company }) => {
  return (
    <span>
      <B>{company.name}</B>, pessoa jurídica de direito privado com sede
      comercial estabelecida em {company.address} inscrita no Cadastro Nacional
      de Pessoa Jurídica CNPJ sob o n.º {company.cnpj}, doravante denominada{" "}
      <B>Contratada/Locadora</B>
    </span>
  );
};

export const InlineClient = ({ client }: { client: Client }) => {
  const entity =
    client.type === "pf"
      ? "pessoa física"
      : "pessoa jurídica de direito privado";
  const place =
    client.type === "pf" ? "endereço" : "sede comercial estabelecida";
  const documentType = client.type === "pf" ? "CPF" : "CNPJ";

  return (
    <span>
      <B>{client.name}</B>, {entity} com {place} na cidade de{" "}
      {`${client.city}/${client.state}`}, em {client.street}, {client.number} -{" "}
      {client.zipcode}, inscrita no {documentType} sob o n.º {client.document},
      doravante denominada <B>Contratante</B>
    </span>
  );
};
